import { render } from "./TestInstructionsStepFive.vue?vue&type=template&id=09f75c53&scoped=true&ts=true"
import script from "./TestInstructionsStepFive.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepFive.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepFive.vue?vue&type=style&index=0&id=09f75c53&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f75c53"]])

export default __exports__